/**
 * System API Service (익명 흐름 가능)
 * 의도적으로 공개해야 하는 시스템 시드 데이터만 전용 엔드포인트로 제공.
 * 범용 코드 조회(/api/codes/...)는 익명 노출 위험으로 미사용.
 */
import api from './index';

export const systemApi = {
    /**
     * 지원 언어 목록 조회.
     * 응답: { data: { result, list: [{ codeCd, codeName, val1, seq }] } }
     */
    getSupportedLanguages() {
        return api.get('/api/system/supported-languages');
    },
};
